import {gql} from "@apollo/client";

export const DELETE_S3_FILE = gql`
    mutation DeleteFile($filename: String!) {
        deleteFile(filename: $filename) {
            status
            msg
        }
    }
`;